<template>
  <section
    id="menu"
    class=""
    :class="{ visible: this.$store.state.menu_is_visible }"
  >
    <div
      v-if="userType == 2"
      v-for="(item, index) in menu"
      class="item"
      :class="{ selected: item.url === path, disabled: item.disabled }"
    >
      <router-link :to="item.url">
        <div class="icon-container">
          <img class="img" :src="item.img" @click.self="select(item)" />
          <span v-if="unreadMessages > 0 && item.url === '/admin/orders'" class="notification-dot"></span>
          <span v-if="unreadMessages > 0 && item.url === '/admin/mop'" class="notification-dot"></span>
        </div>
        <div class="content">
          <span class="name">{{ item.name }}</span>
          <span v-if="item.description" class="description">{{
            item.description
          }}</span>
          <span v-if="item.disabled" class="disabled">{{ $t('general.soon') }}</span>
        </div>
      </router-link>
      <Searcher string="" :refresh="true" v-if="item.search"></Searcher>
    </div>
    <div
      v-if="userType == 4"
      v-for="(item, index) in menu"
      class="item"
      :class="{ selected: item.url === path, disabled: item.disabled }"
    >
      <router-link :to="item.url">
        <div class="icon-container">
          <img class="img" :src="item.img" @click.self="select(item)" />
          <span v-if="unreadMessages > 0 && item.url === '/admin/orders'" class="notification-dot"></span>
          <span v-if="unreadMessages > 0 && item.url === '/admin/mop'" class="notification-dot"></span>
        </div>
        <div class="content">
          <span class="name">{{ item.name }}</span>
          <span v-if="item.description" class="description">{{
            item.description
          }}</span>
          <span v-if="item.disabled" class="disabled">{{ $t('general.soon') }}</span>
        </div>
      </router-link>
      <Searcher string="" :refresh="true" v-if="item.search"></Searcher>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    userType() {
      return this.$store.getters["user/getType"];
    },
    path() {
      return this.$route.path;
    },
    menu() {
      const menu = this.$store.getters["locations/getMenu"];
      const market = this.$store.getters["getMarket"];
      if (this.userType == 2) {
        return menu.admin[market].menuFull;
      } else {
        return menu.admin[market].menuReduced;
      }
    },
    unreadMessages() {
      const userType = this.$store.getters["user/getType"];
      console.log('unreadMessages', userType);
      if (userType) {
        this.$store.dispatch('orders/loadUnreadMessages', userType);
      }
      return this.$store.getters["orders/getUnreadMessages"];
    }
  },
  methods: {
    select(item) {
      if (!item.disabled) {
        for (var k in this.menu) {
          this.menu[k].selected = false;
        }
        item.selected = true;
        this.$store.commit("setMenuVisible", false);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#menu {
  width: 100%;
  background: #222;
  border-bottom: 2px solid var(--main_color);
  padding: 10px 20px;
  position: relative;
  overflow: hidden;
  display: none;

  &.visible {
    display: block;
  }
  .item {
    width: 25%;
    padding: 6px;
    float: left;
    height: 80px;
    text-decoration: none;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);

      .img {
      }
    }
    &.selected {
      .content {
        .name {
          color: var(--main_color);
        }
      }
    }
    .icon-container {
      position: relative;
      float: left;
      
      .img {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-top: 10px;
      }

      .notification-dot {
        position: absolute;
        top: 8px;
        right: -4px;
        width: 8px;
        height: 8px;
        background-color: red;
        border-radius: 50%;
        display: inline-block;
      }
    }
    .content {
      display: inline-block;
      width: calc(100% - 40px);
      padding: 10px;
      text-align: left;

      .name-container {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .name {
        font-weight: bold;
        color: var(--dark_color);
        font-size: 13pt;
        color: #eee;
      }
      .description {
        display: block;
        font-size: 9.5pt;
        color: #777;
      }
      .disabled {
        display: block;
        font-size: 9.5pt;
        color: #777;
      }
    }
    .search {
      margin-top: -5px;
    }
  }
}
</style>
